import React from 'react'
import FileIcon from 'react-file-icon'
import { connect } from 'react-redux'
import ListElement from '../../components/controls/ListElement'
import ListInput from '../../components/controls/ListInput'
import Progress from '../../components/controls/Progress'
import * as actions from '../../store/actions'
import { styles } from '../../styles/FileIconStyle'

class ZalacznikiRow extends React.Component {
  state = {
    isUploading: false,
  }

  getExtension = name =>
    name
      .split('.')
      .slice(-1)
      .toString()

  checkFileName = name => {
    let regexp = new RegExp('^[a-zA-Z0-9_.-]{5,55}$')
    return regexp.test(name)
  }

  controller

  handleChange = e => {
    const { index, idPliku, onAttach, onSetSectionDataArray } = this.props
    this.controller = new AbortController()
    const {signal} = this.controller
    this.setState({ isUploading: true })
    onSetSectionDataArray(e.target.files[0].name, index, 'Nazwa')
    onAttach(idPliku, e.target.files[0], signal).then(res => {
      onSetSectionDataArray(res.Id, index, 'Id')
      this.setState({ isUploading: false })
    })
  }

  handleAbortClick = () => {
    const { index, onSetSectionDataArray } = this.props
    this.controller.abort()
    onSetSectionDataArray(null, index, 'Nazwa')
  }

  getOptions = () => {
    const {
      data,
      index,
      onDeleteDetail,
      handleDelete,
      onDowloadAttachment,
    } = this.props

    let options = []
    if (data.Nazwa)
      options.push({
        title: 'POBIERZ',
        action: () =>
          onDowloadAttachment && onDowloadAttachment(data.Id, data.Nazwa),
      })
    options.push({
      title: 'USUŃ INFORMACJĘ',
      action: handleDelete
        ? () => handleDelete(index)
        : () => onDeleteDetail(index),
    })
    return options
  }

  render() {
    const { data, index, onSetSectionDataArray, hasError } = this.props
    return (
      <>
        <ListElement key={data.Id} options={this.getOptions()}>
          <div className="attachment">
            <ListInput
              name="Opis"
              hasError={(name, value) => hasError(name, value)}
              value={data.Opis}
              onValueChange={e => onSetSectionDataArray(e, index, 'Opis')}
            />
            {data.Nazwa ? (
              <div>
                <div className="fileInfo">
                  <FileIcon
                    size={40}
                    extension={this.getExtension(data.Nazwa)}
                    type="document"
                    {...styles[this.getExtension(data.Nazwa)]}
                    labelUppercase={true}
                  />
                  <div>
                    <p data-cy="zalacznik-name" className="name">
                      {data.Nazwa}
                    </p>
                    {this.checkFileName(data.Nazwa) || (
                      <span className="badFileName caption">
                        nazwa pliku: bez spacji i polskich znaków, 5-55 znaków
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="zalacznikiContainer">
                <label className="fileContainer caption">
                  DODAJ ZAŁĄCZNIK
                  <input
                    data-cy="zalacznik-upload"
                    type="file"
                    onChange={this.handleChange}
                  />
                </label>
              </div>
            )}
          </div>
        </ListElement>
        <Progress
          isOpen={this.state.isUploading}
          abortClick={this.handleAbortClick}
          progressText="Trwa dodawanie załącznika..."
        />
      </>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  onAttach: (id, file, signal) => {
    return dispatch(actions.uploadAttachment(id, file, signal))
  },
  onDeleteDetail: index => {
    dispatch(actions.deleteDetail(index))
  },
})

export default connect(
  null,
  mapDispatchToProps,
)(ZalacznikiRow)
